export const ExpiredLinkModal: string = 'ExpiredLinkModal';
